import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const api = axios.create({ baseURL: `${API_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

export const authApi = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),
  me: () => api.get('/auth/me'),
};

export const usersApi = {
  list: () => api.get('/users'),
  create: (data: { username: string; password: string; role: string }) =>
    api.post('/users', data),
  remove: (id: number) => api.delete(`/users/${id}`),
  changePassword: (id: number, password: string) =>
    api.post(`/users/${id}/password`, { password }),
};

export const sheepApi = {
  list: (mine?: boolean) => api.get('/sheep', { params: mine ? { mine: '1' } : {} }),
  get: (id: number) => api.get(`/sheep/${id}`),
  getPublic: (id: number) => api.get(`/sheep/public/${id}`),
  getPublicPedigree: (id: number) => api.get(`/sheep/public/${id}/pedigree`),
  getFullPedigree: (id: number) => api.get(`/sheep/${id}/full-pedigree`),
  getPublicFullPedigree: (id: number) => api.get(`/sheep/public/${id}/full-pedigree`),
  pedigree: (id: number) => api.get(`/sheep/${id}/pedigree`),
  qr: (id: number) => api.get(`/sheep/${id}/qr`),
  create: (data: any) => api.post('/sheep', data),
  update: (id: number, data: any) => api.put(`/sheep/${id}`, data),
  remove: (id: number) => api.delete(`/sheep/${id}`),
  getPhotos: (id: number) => api.get(`/sheep/${id}/photos`),
  getPublicPhotos: (id: number) => api.get(`/sheep/public/${id}/photos`),
  addPhoto: (id: number, file: File, caption?: string) => {
    const form = new FormData();
    form.append('photo', file);
    if (caption) form.append('caption', caption);
    return api.post(`/sheep/${id}/photos`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  deletePhoto: (photoId: number) => api.delete(`/sheep/photos/${photoId}`),
  updateCaption: (photoId: number, caption: string) =>
    api.put(`/sheep/photos/${photoId}/caption`, { caption }),
};

export const eventsApi = {
  list: (sheepId: number) => api.get(`/sheep/${sheepId}/events`),
  listPublic: (sheepId: number) => api.get(`/sheep/public/${sheepId}/events`),
  create: (sheepId: number, data: any) => api.post(`/sheep/${sheepId}/events`, data),
  update: (id: number, data: any) => api.put(`/events/${id}`, data),
  remove: (id: number) => api.delete(`/events/${id}`),
};
